<template>
    <div>
        <a class="mr-1" href="javascript:void(1);" @click="toggleBlocked" v-b-tooltip.hover title="Alterar Status de Bloqueio ?">
            <i class="fas fa-edit"></i>
        </a>
        <div v-if="isBlocked" class="text-danger">
            Bloqueado
        </div>
        <div v-else class="text-success">
            Ativo
        </div>
    </div>
</template>

<script>
export default {
    props: ['student'],

    data() {
        return {
            loading: false,
            form: {
                status: null
            }
        }
    },

    computed: {

        isBlocked() {
            return this.student.blockeds.length > 0
        }

    },

    created() {
        this.form.status = this.isBlocked;
    },

    methods: {

        async submit() {
            this.loading = true;
            await axios.put('/teacher/students/' + this.student.id + '/blockeds', this.form)
                .then((result) => {
                    // Callback
                    this.$emit('updated')

                    // Message
                    this.$toast.success('Status de Bloqueio foi alterado com sucesso !')
                })
                .finally(() => this.loading = false)
        },

        async toggleBlocked() {
            await this.$bvModal.msgBoxConfirm('Deseja realmente alterar o  status de bloqueio do aluno ?', {
                cancelTitle: 'Cancelar',
                okTitle: 'Alterar',
                cancelVariant: 'default',
                okVariant: 'primary'
            }).then(async answer => {
                if (answer) {
                    this.form.status = !this.isBlocked;
                    await this.submit();
                }
            })
        }
    }
}
</script>

<style scoped>

</style>
